import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { TitledBoxedTextWithModal } from "@coworker/apprestructured/src/task-management/components/TitledBoxedTextWithModal/TitledBoxedTextWithModal";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

function TitledBoxedTextWithModalDemo() {
  const [title, setTitle] = useState("Section Title");
  const [subTitle, setSubTitle] = useState("Optional subtitle");
  const [listItemTitle, setListItemTitle] = useState("5 pieces in 1 media");
  const [modalTitle, setModalTitle] = useState("1 media");
  const [modalContent, setModalContent] = useState(
    "This is the modal content.\nYou can put any component here."
  );
  const [disabled, setDisabled] = useState(false);
  const [hasSubtitle, setHasSubtitle] = useState(true);

  return (
    <Demo>
      <Name>TitledBoxedTextWithModal</Name>
      <Highlight>
        <TitledBoxedTextWithModal
          title={title}
          subTitle={hasSubtitle ? subTitle : undefined}
          listItemTitle={listItemTitle}
          testId="demo-titled-boxed-text-modal"
          disabled={disabled}
          modalTitle={modalTitle}
          modalContent={
            <div>
              {modalContent.split("\n").map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
            </div>
          }
          onSave={() => {
            console.log("Modal saved!");
          }}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="Title"
          type="text"
          id="titled-boxed-text-modal-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaCheckbox
          id="titled-boxed-text-modal-has-subtitle"
          label="Show subtitle"
          value="has-subtitle"
          checked={hasSubtitle}
          onChange={() => setHasSubtitle(!hasSubtitle)}
        />
        {hasSubtitle && (
          <FixaInputField
            label="Subtitle"
            type="text"
            id="titled-boxed-text-modal-subtitle"
            value={subTitle}
            onChange={(e) => setSubTitle(e.target.value)}
          />
        )}
        <FixaInputField
          label="List item title"
          type="text"
          id="titled-boxed-text-modal-list-item-title"
          value={listItemTitle}
          onChange={(e) => setListItemTitle(e.target.value)}
        />
        <FixaInputField
          label="Modal title"
          type="text"
          id="titled-boxed-text-modal-modal-title"
          value={modalTitle}
          onChange={(e) => setModalTitle(e.target.value)}
        />
        <FixaTextArea
          id="titled-boxed-text-modal-content"
          label="Modal content (one line per line)"
          rows={5}
          value={modalContent}
          onChange={(e) => setModalContent(e.target.value)}
        />
        <FixaCheckbox
          id="titled-boxed-text-modal-disabled"
          label="Disabled"
          value="disabled"
          checked={disabled}
          onChange={() => setDisabled(!disabled)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(TitledBoxedTextWithModalDemo);
